import { Link, List, ListItem, ListItemText } from '@mui/material';
import React from 'react';

import { snackbarMessageTextStyles } from '../../../components/Snackbar';

const SuccessfulConversion = () => {
  return (
    <>
      Going forward, sign in directly to MyPolicy to manage your insurance.
      <List
        sx={{
          pl: 4,
          py: 1,
          listStyleType: 'disc',
          '& .MuiListItem-root': {
            display: 'list-item',
          },
        }}
        component="ul"
      >
        <ListItem
          sx={{
            py: 0,
            pl: 0.5,
            pr: 0,
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
          }}
        >
          <ListItemText
            primaryTypographyProps={{
              sx: { ...snackbarMessageTextStyles },
            }}
          >
            Bookmark{' '}
            <Link
              href="https://www.mypolicy.csaa-insurance.aaa.com/login"
              target="_blank"
              underline="none"
              sx={{
                ...snackbarMessageTextStyles,
              }}
            >
              https://www.mypolicy.csaa-insurance.aaa.com/login
            </Link>
          </ListItemText>
        </ListItem>
        <ListItem sx={{ py: 0, pl: 0.5, pr: 0 }}>
          <ListItemText
            primaryTypographyProps={{
              sx: { ...snackbarMessageTextStyles },
            }}
          >
            Sign in with the same email you&apos;ve used before and your new
            password
          </ListItemText>
        </ListItem>
        <ListItem sx={{ py: 0, pl: 0.5, pr: 0 }}>
          <ListItemText
            primaryTypographyProps={{
              sx: { ...snackbarMessageTextStyles },
            }}
          >
            Continue to visit AAA.com for your AAA membership
          </ListItemText>
        </ListItem>
      </List>
      We&apos;ll send you an email to confirm this change.
    </>
  );
};

export default SuccessfulConversion;
